module.exports = __webpack_public_path__ + "img/bg.074eb05d.jpg";